import AbstractTextSearch from 'common/AbstractTextSearch';

// import CrewMemberAutoCompleteV2 from '../../../common/СrewMemberAutocompleteV2';
import DateRangeFilterWA from './DaterangeFilterWA';
import LocationSearchV2 from './LocationSearchMulti';
import MobilityPartnerFieldMulti from './MobilityPartnerMulti';
import ReconciliationStatusFilter from './ReconciliationStatusFilter';
import RunNames from './RunNames';
import TripNumbers from './TripNumbers';

import styles from './styles.module.css';

const FiltersWorkAssignments = ({ store }) => (
	<div className={styles.container}>
		<div className={styles.input}>
			<RunNames
				value={store.filters.runNames}
				onSelection={(value) => store.addFilterItem('runNames', value)}
				onReset={() => store.resetFilter('runNames')}
				onSingleItemReset={(value) => store.removeFilterItem('runNames', value)}
				extraClasses={styles.fullwidth}
			/>
		</div>

		<div className={styles.input}>
			<TripNumbers
				value={store.filters.tripNumbers}
				onSelection={(value) => store.addFilterItem('tripNumbers', value)}
				onReset={() => store.resetFilter('tripNumbers')}
				onSingleItemReset={(value) => store.removeFilterItem('tripNumbers', value)}
				extraClasses={styles.fullwidth}
			/>
		</div>

		<div className={styles.input}>
			<AbstractTextSearch
				value={store.filters.assignee}
				onChange={(value) => {
					store.updateFilter('assignee', value);
					store.resetFilter('crewMember');
				}}
				onReset={() => {
					store.resetFilter('assignee');
					store.resetFilter('crewMember');
				}}
				label="Assignee"
				placeholder="Start typing (name or employee number)"
				withIcon={false}
			/>
		</div>
		<div className={styles.input}>
			<DateRangeFilterWA
				value={store.filters.dateRange}
				onChange={(value) => store.updateFilter('dateRange', value)}
				onReset={() => store.resetFilter('dateRange')}
				withIcon={false}
			/>
		</div>
		<div className={styles.input}>
			<LocationSearchV2
				value={store.filters.cities}
				onSelection={(item) => store.addFilterItem('cities', item)}
				onReset={() => store.resetFilter('cities')}
				onSingleItemReset={(item) => store.removeFilterItem('cities', item)}
				label="Location"
				placeholder="e.g. Boston"
				searchOnlyWithStations={false}
				extraClasses={styles.fullwidth}
				withIcon={false}
			/>
		</div>
		<div className={styles.input}>
			<MobilityPartnerFieldMulti
				value={store.filters.mobilityPartners}
				onSelection={(item) => store.addFilterItem('mobilityPartners', item)}
				onReset={() => store.resetFilter('mobilityPartners')}
				onSingleItemReset={(item) => store.removeFilterItem('mobilityPartners', item)}
				extraClasses={styles.fullwidth}
			/>
		</div>
		<div className={styles.input}>
			<ReconciliationStatusFilter
				value={store.filters.reconciliationStatus}
				onChange={(value) => store.updateFilter('reconciliationStatus', value)}
				onReset={() => store.resetFilter('reconciliationStatus')}
				extraClasses={styles.fullwidth}
			/>
		</div>
	</div>
);
export default FiltersWorkAssignments;
